// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_qRY","cls2":"VideoPlayerMainContent-cls2_z6P VideoPlayerMainContent-cls1_qRY"};